import { CoreModule } from 'core/core.module';
import { HomeModule } from './home/home.module';
import { SharedModule } from './shared/shared.module';

export const APP_MODULES = [CoreModule, HomeModule, SharedModule];
